import React, { Component } from "react";
import { Route } from "react-router-dom";
import { Modal } from "carbon-components-react";
import { toast } from "react-toastify";
import { Breadcrumb, Tabs } from "../../../components";
import EditCampaign from "./EditCampaign";
import Comments from "./Comments";
import {getByDmService, pathDmService } from '../../../services/Api';

export default class Detail extends Component {
  constructor(props){
    super(props)
    this.state = {
      nrComents: 0,
      loadView: 0,
      cancelModal: false,
      nivel: 0,
      status: {id:0}
    }
  }

  componentWillMount(){
    const {match, history} = this.props;
    const {path, params} = match
    const {loadView} = this.state;
    const user = JSON.parse(localStorage.getItem('user'));
    const nivel = (user.nivel || {}).id;
    this.setState({nivel});

    this.countComment()
    if(loadView === 0){
      if(path === "/pedido/comunicacao/campanha/:id"){
        history.push(`/pedido/comunicacao/campanha/${params.id}/informacoes`);
        localStorage.setItem("urlReturn", "/pedidos/comunicacao");
      }
      this.setState({
        loadView: 1
      })
    }
  }

  goListCampaign = () => {
    const { history } = this.props;
    const historyLocation = localStorage.getItem("urlReturn");
    history.push(historyLocation);
  };

  countComment = async () => {
    await this.load()
  }

  load = async() => {
    const {match} =  this.props;

    const data = await getByDmService(`/Pedido/GetCampanhaMensagem`, match.params.id) || {};
 
    if(data.itensCampanhaMensagem && data.itensCampanhaMensagem.length){
      const urlIdComents = await data.itensCampanhaMensagem[0].id;
      const dataComent = await getByDmService('/Comentario/GetByItemPedido', urlIdComents);    
      const numberComents = await dataComent.length;
      await this.setState({
        nrComents: numberComents, ...data
      });   
    }
  }

  cancelOrder = async () => {
    await this.updateOrderStatus(5);
    toast.info('O pedido foi cancelado');
    this.toggleCancelModal();
  };
  
  toggleCancelModal = () => {
    this.setState(prevState => ({ cancelModal: !prevState.cancelModal }));
  };

  updateOrderStatus = async status => {
    const { id } = this.state;
    const { match } = this.props;
    const _id = status === 7 ? match.params.id : id;
    const serviceUrl =
      status === 7
        ? `/Pedido/AtualizaStatusData/${_id}?status=${status}`
        : `/Pedido/AtualizaStatus/${_id}?status=${status}&retirouUniforme=&dataRetiradaUniforme=`;
    try {
      await pathDmService(serviceUrl);
      await this.load();
    } catch (e) {
      toast.error('Ocorreu um erro ao alterar o status do pedido');
    }
  };

  render() {
    const { match } = this.props;
    const urlVisited = match.path;
    const arrayUrlVisited = urlVisited.split('/');
    const isRequest = arrayUrlVisited[1] === "pedido";
    const {nrComents, numero, status, cancelModal, nivel} = this.state;
    
    return (
      <div>
        <Breadcrumb
          title={`${numero && parseInt(numero.replace(/[^0-9]/g, ''), 10) > 0 ? `${numero} - ` : ''} Campanha de Mensagens`}
          renderLeft={(() => (
            <div
              className="breadcrumb-left-actions pointer"
              onClick={() => this.goListCampaign()}
            >
              <svg width="16" height="14" viewBox="0 0 16 14">
                <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
              </svg>
            </div>
          ))()}          
          renderRight={
            ((nivel === 10 && status.id !== 5) || [3, 4].indexOf(status.id) > -1) && (
              <div className="flex v-sm-margin">
                <button
                  className="bx--btn btn-primary-outlined h-sm-margin"
                  onClick={this.toggleCancelModal}
                  type="submit"
                >
                  Cancelar Campanha
                </button>
              </div>
            )}
        />
        <section className="content-wrapper content-wrapper--large">
          {isRequest && (
            <Tabs
              sections={[
                { title: 'Detalhe da Campanha', path: `${match.url}/informacoes` },
                { title: `Comentários`, path: `${match.url}/comentarios`, badge: nrComents},
              ]}
            />
          )
          }
          <Route
            path={`${match.url}/informacoes`}
            render={props => <EditCampaign numero={numero} {...props} />}
          />
          <Route
            path={`${match.url}/comentarios`}
            render={props => <Comments {...props} updateCount={this.countComment} />}
          />
          <Modal
            open={cancelModal}
            onRequestSubmit={this.cancelOrder}
            onRequestClose={this.toggleCancelModal}
            modalHeading="Cancelar Campanha"
            primaryButtonText="Tenho certeza"
            secondaryButtonText="Cancelar"
          >
            <div className="warning-modal-txt">
              <p>Você tem certeza que deseja cancelar esta campanha?</p>
            </div>
          </Modal>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/client/campaigns/Detail.js